import React from "react";
import "../styles/project.css";

const CodingJudge = () => {
  return (
    <div className="project-content">
      <h2>Backend Development Intern - Coding Judge</h2>
      <h3>(May 2024 to Present) <a href = "https://codingjudge.com" target = "_blank">Link</a></h3>
      <li>
        Boosted platform performance by 20% by implementing caching mechanisms.
        This optimization significantly decreased load times, enhancing the user
        experience and ensuring a smoother, more responsive platform.
      </li>
      <li>
        Executed comprehensive load testing, identifying critical system flaws.
        These insights were pivotal, resulting in a 30% improvement in
        performance metrics and a 20% increase in system reliability,
        culminating in a platform that is not only more stable but also
        significantly more efficient.
      </li>
      <li>
        Revamped system monitoring and troubleshooting capabilities with a
        sophisticated logger that meticulously tracks real-time user and admin
        activities. This solution significantly accelerated incident response
        times while offering invaluable insights for vigilant system maintenance
        and fortified security measures.
      </li>
      <li>
        Improved user security by implementing a Two-Factor Authentication (2FA)
        feature specifically for passwords. This solution reduced account
        recovery issues by 80%, ensuring a more secure and trustworthy
        authentication system.
      </li>
      <li>
        Enabled clients to effectively monitor batch statistics by developing a
        comprehensive admin dashboard. This tool provided detailed insights,
        significantly enhancing management capabilities. Additionally, the
        automated email feature streamlined communication, keeping course owners
        well-informed and engaged.
      </li>
      <li>
        Automated content addition to courses by scripting CSV data to database
        entry conversion in Django, reducing manual entry time by 50% and
        ensuring a 95% increase in content management accuracy and consistency
      </li>
    </div>
  );
};

export default CodingJudge;
